// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_kwj","cls2":"Comments-cls2__5g Comments-cls1_kwj"};